import c0 from './dashboard/channels/episodes/form_controller';
import c1 from './dashboard/channels/episodes/hls_preview_controller';
import c2 from './dashboard/channels/episodes/upload_controller';
import c3 from './dashboard/channels/landing_page/testimonials_controller';
import c4 from './dashboard/channels/live_events/audience_controller';
import c5 from './dashboard/shared/email_customizations/form_fields_controller';
import c6 from './dashboard/shared/posts/author_controller';
import c7 from './dashboard/shared/posts/auto_resize_controller';
import c8 from './dashboard/shared/posts/form_controller';
import c9 from './dashboard/shared/posts/headline_image_controller';
import c10 from './dashboard/shared/posts/title_controller';
import c11 from './dashboard/shared/searches/search_results_controller';
export const definitions = [
	{identifier: 'dashboard--channels--episodes--form', controllerConstructor: c0},
	{identifier: 'dashboard--channels--episodes--hls-preview', controllerConstructor: c1},
	{identifier: 'dashboard--channels--episodes--upload', controllerConstructor: c2},
	{identifier: 'dashboard--channels--landing-page--testimonials', controllerConstructor: c3},
	{identifier: 'dashboard--channels--live-events--audience', controllerConstructor: c4},
	{identifier: 'dashboard--shared--email-customizations--form-fields', controllerConstructor: c5},
	{identifier: 'dashboard--shared--posts--author', controllerConstructor: c6},
	{identifier: 'dashboard--shared--posts--auto-resize', controllerConstructor: c7},
	{identifier: 'dashboard--shared--posts--form', controllerConstructor: c8},
	{identifier: 'dashboard--shared--posts--headline-image', controllerConstructor: c9},
	{identifier: 'dashboard--shared--posts--title', controllerConstructor: c10},
	{identifier: 'dashboard--shared--searches--search-results', controllerConstructor: c11},
];
